import { Flex, IconButton, Link, Text, VStack } from '@chakra-ui/react';
import { FaGithub, FaLinkedinIn } from 'react-icons/fa';

import { ThemeToggle } from '$components/ui/theme-toggle';
import { social } from '$shared/social';

interface FooterProps {
  isLargeScreen: boolean;
}

const iconButtonProps = {
  variant: 'ghost' as const,
  size: 'sm' as const,
  bg: 'transparent',
  color: 'text.muted',
  borderRadius: '999px',
  borderWidth: '1px',
  borderColor: 'line.subtle',
  h: '40px',
  w: '40px',
  minW: '40px',
  _hover: {
    color: 'accent.500',
    borderColor: 'accent.line',
    bg: 'transparent',
  },
  _active: { bg: 'transparent' },
};

const textLinks = [
  { href: `mailto:${social.email}`, label: 'Email', external: false },
  { href: social.resume, label: 'Currículo', external: true },
];

export function Footer({ isLargeScreen }: FooterProps) {
  if (isLargeScreen) {
    return (
      <Flex align="center" gap="8px">
        <IconButton
          as={Link}
          href={social.github}
          isExternal
          aria-label="GitHub"
          icon={<FaGithub />}
          fontSize="16px"
          {...iconButtonProps}
        />
        <IconButton
          as={Link}
          href={social.linkedin}
          isExternal
          aria-label="LinkedIn"
          icon={<FaLinkedinIn />}
          fontSize="15px"
          {...iconButtonProps}
        />
        <ThemeToggle />
      </Flex>
    );
  }

  return (
    <VStack align="start" spacing="20px" pt="20px" w="full">
      <Flex align="center" gap="8px">
        <IconButton
          as={Link}
          href={social.github}
          isExternal
          aria-label="GitHub"
          icon={<FaGithub />}
          fontSize="16px"
          {...iconButtonProps}
        />
        <IconButton
          as={Link}
          href={social.linkedin}
          isExternal
          aria-label="LinkedIn"
          icon={<FaLinkedinIn />}
          fontSize="15px"
          {...iconButtonProps}
        />
        <ThemeToggle />
      </Flex>

      <VStack align="start" spacing="10px" w="full">
        <Text
          fontFamily="mono"
          fontSize="11px"
          letterSpacing="0.16em"
          textTransform="uppercase"
          color="text.faint"
        >
          Direto
        </Text>
        <Flex wrap="wrap" gap="14px">
          {textLinks.map((item) => (
            <Link
              key={item.label}
              href={item.href}
              isExternal={item.external}
              fontSize="14px"
              color="text.muted"
              _hover={{ color: 'accent.500' }}
              transition="color 0.2s ease"
            >
              {item.label} {item.external ? '↗' : ''}
            </Link>
          ))}
        </Flex>
      </VStack>
    </VStack>
  );
}
